import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  addFilterableTarget() {
    this.element.dataset.onPageFilterTarget = 'filterable'
  }

  removeFilterableTarget() {
    this.element.dataset.onPageFilterTarget = undefined
  }
}
